import { ICancelContinueModal, IConfirmModal } from "interfaces/IModal";
import CancelContinue from "./CancelContinueModal";
import ConfirmationModal from "./ConfirmationModal";

/**
 * Custom props for the modal handler
 */
interface Props {
    /**
     * A collection of modal components that contains the different props of each step modal
     */
    modal: IConfirmModal | ICancelContinueModal;
}

/**
 * A component that handles the different flux of modal of certain processes
 */
export const ModalHandler = ({ modal }: Props) => {

    // Type guard for ICancelContinueModal 
    const isCancelContinueModal = (obj: any): obj is ICancelContinueModal => { return 'onConfirm' in obj; }
    
    return (
        isCancelContinueModal(modal)
            ?
            <CancelContinue
                show={modal.show}
                onHide={modal.onHide}
                onConfirm={modal.onConfirm}
                title={modal.title}
                message={modal.message}
                icon={modal.icon}
                iconColor={modal.iconColor}
            />
            :
            <ConfirmationModal
                show={modal.show}
                onHide={modal.onHide}
                title={modal.title}
                message={modal.message}
                icon={modal.icon}
                iconColor={modal.iconColor}
            />
    )
}
